import React, { useState, useContext } from "react";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import circle_logo from "../assets/images/circle_logo.png";
import ApiConfig from "../api/ApiConfig";
import { AppContext } from "../context/AppContext";
import { ToastContainer, toast } from "react-toastify";

import { ToastMsg } from "./TostMsg";
import { PostCallWithErrorResponse } from "../api/ApiServices";

const Login = ({ setLoggedIn }) => {
  const navigate = useNavigate();
  const { sidebar, adminData, setAdminData } = useContext(AppContext);
  const [loader, setLoader] = useState(false);
  const [adminDetails, setAdminDetails] = useState({
    emailId: "",
    password: "",
  });

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      logInApiCall();
    }

    setValidated(true);
  };

  const logInApiCall = () => {
    const body = {
      mail_id: adminDetails.emailId,
      password: adminDetails.password,
    };
    setLoader(true);
    PostCallWithErrorResponse(ApiConfig.LOGIN, JSON.stringify({ ...body }))
      .then((res) => {
        console.log("LOGIN RESPONSE", res)
        setLoader(false);
        if (res.json?.result == true || res.error == false) {
         console.log(res,"res")
          setLoggedIn(true);
          setAdminData({
            authorization: res.json.data.accessToken,
            user_id: res.json.data.user_id,
          });
          localStorage.setItem("accessToken", res.json.data.accessToken);
          localStorage.setItem("mail_id", res.json.data.mail_id);
          localStorage.setItem("user_id", res.json.data.user_id);
          localStorage.setItem("logedIn", true);
          navigate("/Dashboard");
        } else {
          // alert("Invalid Credentials")
          ToastMsg("error","Invalid Credentials");
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <main className="main-login">
      <div className="wrapper row">
        <div className="left col-md-8">
          <div className="logo">
            <img src={circle_logo} alt="" />
          </div>
        </div>
        <div className="right col-md-4">
          <div className="inner-form">
            <div className="text-center mb-4 heading-login">
              <h2>Welcome</h2>
              <label htmlFor="">Please enter your credentials</label>
            </div>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <div className="mb-3">
                <Form.Control
                  required
                  type="email"
                  onChange={(e) =>
                    setAdminDetails({
                      ...adminDetails,
                      emailId: e.target.value,
                    })
                  }
                />

                <Form.Control.Feedback
                  type="invalid"
                  placeholder="Email Address"
                >
                  Please Enter Your Email.
                </Form.Control.Feedback>
              </div>
              <div className="mb-4">
                <Form.Control
                  required
                  type="password"
                  onChange={(e) =>
                    setAdminDetails({
                      ...adminDetails,
                      password: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter your password.
                </Form.Control.Feedback>
              </div>
              <div className="login-btn-main ">
                {/* <button className="" type="submit">
                  Login
                </button> */}
                {/* <Link to="/Dashboard" className="innerLink"></Link> */}

                <button className="cx-btn-1" type="submit">
                  {loader ? (
                    <>
                    <div
                      className="spinner-border mx-auto me-2"
                      style={{
                        color: "#fff",
                        width: "17px",
                        height: "17px",
                      }}
                    ></div>
                                        <span> Login</span>

                  </>
                  
                  
                  ):(<>
                    <span> Login</span>

</>)}
                  
                </button>
                <ToastContainer />
              </div>
            </Form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;
